import React, { useMemo } from 'react'
import Loader from '../Loader'
import NoDataAvailable from '../NoDataAvailable'
import InfiniteScrollData from './InfiniteScrollData'
import useRecentGames from './hooks/useRecentGames'
import useFavoriteGames from 'hooks/useFavoriteGames'

const RecentGamesGrid = () => {
  const {
    recentGames,
    userDetails,
    selectedLanguageCode,
    languageData,
    recentGamesLoading
  } = useRecentGames({ category: true })

  const { favoriteGamesList, toggleFavorite } = useFavoriteGames()

  const games = useMemo(() => ({
    rows: recentGames || [],
    count: recentGames?.length || 0
  }), [recentGames])

  if (!userDetails?.userId) {
    return null
  }

  if (recentGamesLoading) {
    return (
      <div className='fav-loader'>
        <Loader top='7%' />
      </div>
    )
  }

  if (!games.count) {
    return (
      <div className='text-center mt-4 mb-3'>
        <NoDataAvailable errorMessage={languageData?.noRecentGames || 'No recent games found'} />
      </div>
    )
  }

  return (
    <div className='games-grid-wrapper'>
      <div className='games-grid'>
        <InfiniteScrollData
          games={games}
          toggleFavorite={toggleFavorite}
          selectedLanguageCode={selectedLanguageCode}
          favoriteGamesList={favoriteGamesList}
        />
      </div>
    </div>
  )
}

export default React.memo(RecentGamesGrid)
